import React, { Component } from 'react';
import FormInput from '../FormInput/FormInput';

import { debounce } from '../../utils/utils';

// Component requires an onSearch event. Will call the onSearch event when input is changed or escape key is pressed.
// onSearch will be called with synthetic event and value. Value will be null when input is cleared.

export default class SearchInputDebounce extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.initialValue || '',
      isLoading: false
    };
  }

  debouncedOnSearch = debounce(() => {
    this.setState({ isLoading: false });
    this.props.onSearch(this.state.value);
  }, 200);

  handleKeyDown = (evt) => {
    if (evt.key === 'Escape') {
      this.setState({ isLoading: true });
      this.setState({ value: '' }, this.debouncedOnSearch);
    }
  };

  handleOnChange = (e) => {
    this.setState(
      { value: e.target.value, isLoading: true },
      this.debouncedOnSearch
    );
  };

  render() {
    const { size, placeholder, style, loading } = this.props;
    const { value, isLoading } = this.state;

    return (
      <FormInput
        className="SearchInput"
        autoComplete="off"
        placeholder={placeholder || 'Search'}
        onKeyDown={this.handleKeyDown}
        onChange={this.handleOnChange}
        size={size || 'small'}
        type="search"
        value={value}
        style={{
          width: 225,
          fontFamily: 'Roboto, sans-serif',
          fontSize: '1rem',
          ...style
        }}
        loading={loading || isLoading}
        icon={{ name: 'search', size: 'small' }}
      />
    );
  }
}
